import _get from 'lodash/get';
import {Table} from 'semantic-ui-react';
import * as React from 'react';
import i18n from '../../../../locale/i18n';
import InfiniteScroll from 'react-infinite-scroller';

import "../../components/GenericTableView/GenericTable.css";
import {ColumnDefinition} from './common';
import {WithNamespaces, withNamespaces} from 'react-i18next';

//
//  WIP common used Table components (DataTable, Column Selector, ...)
//    will replace GenericTableView and TableView
//


const t = i18n.t.bind(i18n);

// data is flattened to props, may cause problems when there are field names matching __column, __filter or something from i18n WithNamespaces --
const TableCellComponent = (props:  {__column: ColumnDefinition, __filter?:  { [p: string]: any }, [key:string]: any}) => {
  const column = props.__column;
  const cellContent = column.cellRender ? column.cellRender(_get(props, column.fieldName), props, props.__filter) : _get(props, column.fieldName);

  return (<>
      <Table.HeaderCell className={"responsive"}>{column.labelTranslationKey? t(column.labelTranslationKey) : column.label} {column.popup? column.popup() : <></>}</Table.HeaderCell>
      <Table.Cell className={"responsive" + (column.cellAlign === 'right' ? ' alignRight' : '')}>
        {cellContent}
      </Table.Cell>
    </>);
};

const TableCell = React.memo((TableCellComponent));

const TableRowComponent = (props: {columns: ColumnDefinition[], selectedColumns?: string[]; filter?:  { [p: string]: any }; rowData: any}) => {
  const dataCells = props.columns.map((column, columnIndex) => {
    if(props.selectedColumns && props.selectedColumns.indexOf(column.fieldName) === -1) {
      return null;
    }
    return (<TableCell key={`cell_${columnIndex}`} __filter={props.filter} __column={column} {...props.rowData} />);
  }).filter(cell => cell !== null);

  return (
      <Table.Row>
        {dataCells}
      </Table.Row>
  );
};

const TableRow = React.memo(TableRowComponent);

const TableContentComponent = (props: {columns: ColumnDefinition[], data: any; page: number; totalPages: number; filter?:  { [p: string]: any }; getScrollParent: () => any; loadMore: () => any; selectedColumns?: string[]}) => {
  let rows = null;
  if (props.data != null) {
    const dataSource = Array.isArray(props.data) ? props.data : props.data.content;
    rows = dataSource.map(function (dataRow: any, idx: number) {
      return (
          <TableRow filter={props.filter} key={idx} columns={props.columns} selectedColumns={props.selectedColumns} rowData={dataRow} />
      );
    });

    return (<InfiniteScroll
        element="tbody"
        pageStart={0}
        loadMore={props.loadMore}
        hasMore={props.totalPages > props.page}
        threshold={300}
        useWindow={false}
        getScrollParent={props.getScrollParent}
    >
      {rows}
    </InfiniteScroll>);
  }

  return null;
};

const TableContent = React.memo(TableContentComponent);

const TableHeaderCellComponent = (props: {
  column: ColumnDefinition;
  loading?: boolean;
  handleSortChange?: (field: string) => any;
  sortColumn?: string;
  sortDirection?: 'ASC' | 'DESC';
} & WithNamespaces) => {
  return (
      <Table.HeaderCell
        colSpan={props.column.headerColspan}
          disabled={props.loading || props.column.noSort}
          sorted={props.sortColumn === props.column.fieldName ? (props.sortDirection === 'ASC' ? 'ascending' : 'descending') : undefined}
          onClick={(!props.column.noSort && props.handleSortChange) ? (() => props.handleSortChange && !props.loading ? props.handleSortChange(props.column.fieldName) : false) : undefined}


      >{ props.column.labelTranslationKey? t(props.column.labelTranslationKey) : props.column.label}{props.column.popup? props.column.popup() : <></>}</Table.HeaderCell>
  )
};

const TableHeaderCell = React.memo(withNamespaces()(TableHeaderCellComponent));

const DataTableComponent = (props: {data: any;
  page: number;
  totalPages: number;
  getScrollParent: () => any;
  loadMore: () => any;
  sortColumn?: string;
  sortDirection?: 'ASC' | 'DESC';
  handleSortChange?: (field: string) => any;
  columns: ColumnDefinition[];
  selectedColumns?: string[];
  loading?: boolean;
  filter?:  { [p: string]: any };
  largeHeader?: boolean;
}) => {
  const headerCells = props.columns.map((column, columnIndex) => {
    if(props.selectedColumns && props.selectedColumns.indexOf(column.fieldName) === -1) {
      return null;
    }
    if(column.noHeader) {
      return null;
    }
    return <TableHeaderCell
        key={`th_${columnIndex}`}
        column={column}
        loading={props.loading}
        handleSortChange={props.handleSortChange}
        sortColumn={props.sortColumn}
        sortDirection={props.sortDirection}
    />
  }).filter(cell => cell !== null);
  return (<Table className={"responsive"} celled striped sortable  singleLine
                 unstackable={false}>
    <Table.Header className={ props.largeHeader ? "sticky-header-large" : "sticky-header"}>
      <Table.Row key="0">
        {headerCells}
      </Table.Row>
    </Table.Header>
    <TableContent data={props.data}
                  columns={props.columns}
                  page={props.page}
                  totalPages={props.totalPages}
                  getScrollParent={props.getScrollParent}
                  loadMore={props.loadMore}
                  selectedColumns={props.selectedColumns}
                  filter={props.filter}
    />
  </Table>);
};

export const DataTable = React.memo(DataTableComponent);